export default __webpack_public_path__ + "static/media/aboutUs.ebb955f0.jpeg";